import { initScreens, defaultInjectKey } from '../utils/initScreens';
const plugin = {
    install: (app, screens, opts) => {
        const s = initScreens(screens);
        const key = opts?.injectKey || defaultInjectKey;
        // Inject a globally available screens object method
        app.config.globalProperties[key] = s;
        // Provide screens object
        app.provide(key, s);
    },
};
export default plugin;
//# sourceMappingURL=screens.js.map